import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { Subgrupo } from 'src/app/admihair/api/dto/subgrupo';
import { SubgrupoService } from 'src/app/admihair/service/subgrupo.service';
import { NgForm } from '@angular/forms';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { UnidadeMedidaService } from 'src/app/admihair/service/unidade-medida.service';
import { UnidadeMedida } from 'src/app/admihair/api/dto/unidade-medida';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { FabricanteService } from 'src/app/admihair/service/fabricante.service';
import { Fabricante } from 'src/app/admihair/api/dto/fabricante';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { CustoService } from 'src/app/admihair/service/custo.service';
import { CustoMedio } from 'src/app/admihair/api/dto/custo-medio';


@Component({
  selector: 'app-item-produto-inserir',
  templateUrl: './item-produto-inserir.component.html',
  styleUrls: ['./item-produto-inserir.component.scss']
})
export class ItemProdutoInserirComponent extends AdmihairBaseComponent implements OnInit, AfterViewInit {

  @ViewChild('form') form?: NgForm;
  itemProduto: ItemProduto = this.criarItemProdutoPadrao();
  progressoRequisicao: boolean = false;

  subgrupos: SelectItem[] = [];
  codigoExistente: boolean = false;
  unidadesMedidas: SelectItem[] = [];
  fabricantes: Fabricante[] = [];
  planoContaEmpresa?: PlanoContaEmpresa;

  valorSugerido: number = 0;
  custoMedio: CustoMedio = {
    custoFixo: 0,
    imposto: 0
  };

  novoValor: number = 0;
  valorLucroObtido: number = 0;

  exibirDialogValorSugerido: boolean = false;
  loadingSpinnerDialog: boolean = false;

  constructor(private itemProdutoService: ItemProdutoService,
    private subgrupoService: SubgrupoService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private unidadeMedidaService: UnidadeMedidaService,
    private fabricanteService: FabricanteService,
    private custoService: CustoService,
    storageService: UtilStorageService,
    erroService: ErroService) {
    super(erroService, storageService);
  }
  ngAfterViewInit(): void {
    console.log(this.form)
  }

  ngOnInit(): void {
    this.exibirSpinnerPrincipal = true;
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_PRODUTO');
    if (this.permissaoInserir) {
      this.buscarSubgrupos();
      this.buscarUnidadesMedidas();
      this.buscarFabricantes();
      this.buscarPlanoContaEmpresa();
    }
    console.log(this.itemProduto)
  }


  private criarItemProdutoPadrao(): ItemProduto {
    return {
      descricao: '',
      fabricante: null,
      subgrupo: null,
      valorCompra: 0,
      lucro: 0,
      valorVenda: 0,
      comissaoVenda: 0,
      codigo: '',
      controlaEstoque: false,
      estoqueMinimo: 0,
      estoqueMaximo: 0,
      quantidadeUnidadeMedida: 1,
      descricaoUnidadeMedida: 'UN',
      tributacao: false,
      estoqueAtual: 0,
      ativo: true
    };
  }

  reiniciarFormulario(): void {
    const valoresIniciais = this.criarItemProdutoPadrao();
    this.itemProduto = valoresIniciais;
    this.form?.resetForm(valoresIniciais);
  }

  private definirTributacaoPadrao() {
    this.itemProduto.gtin = 'SEM GTIN';
    this.itemProduto.cstOrigem = '0';
    this.itemProduto.cstTributIcms = '00';
    this.itemProduto.csosn = '102';
    this.itemProduto.cfop = '102';
    this.itemProduto.cstPis = '01';
    this.itemProduto.cstCofins = '01';
    this.itemProduto.aliquotaIcms = this.itemProduto.aliquotaIcms || 0;
    this.itemProduto.aliquotaIcmsEntrada = this.itemProduto.aliquotaIcmsEntrada || 0;
    this.itemProduto.aliquotaPis = this.itemProduto.aliquotaPis || 0.65;
    this.itemProduto.aliquotaCofins = this.itemProduto.aliquotaCofins || 3.00;
    this.itemProduto.fcp = this.itemProduto.fcp || 0;
    this.itemProduto.indEscala = 'S';
    this.itemProduto.cstIbsCbs = '000';
    this.itemProduto.classTrib = '000001'
    this.itemProduto.aliqIsProduto = 0;
  }

  salvar() {
    if (this.form?.invalid || this.codigoExistente || this.progressoRequisicao) {
      return;
    }

    this.progressoRequisicao = true;
    this.itemProduto.empresa = this.getEmpresa();
    if (this.planoContaEmpresa) {
      this.itemProduto.planoContaEmpresa = this.planoContaEmpresa;
    }
    this.itemProduto.descricao = FormatacaoUtil
      .removerCaracteresEspeciais(this.itemProduto.descricao);

    this.definirTributacaoPadrao();

    this.itemProdutoService.salvarItemProduto(this.itemProduto).subscribe({
      next: (data: ItemProduto) => {
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
        this.reiniciarFormulario();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    });
  }


  buscarSubgrupos() {
    this.subgrupoService.listarSubgruposProdutoPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: Subgrupo[]) => {
        this.subgrupos = data.map(item => (
          { label: `${item.grupo?.descricao} - ${item.descricao}`, value: item }
        ));
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  buscarUnidadesMedidas() {
    this.unidadeMedidaService.listarTodas().subscribe({
      next: (data: UnidadeMedida[]) => {
        this.unidadesMedidas = data.map(item => (
          { label: `${item.simbolo} - ${item.descricao}`, value: item.simbolo }));
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    });
  }

  buscarFabricantes() {
    this.fabricanteService.listarFabricantesPorEmpresaId(this.getEmpresa().id).subscribe({
      next: (data: Fabricante[]) => {
        this.fabricantes = data;
        this.exibirSpinnerPrincipal = false;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  buscarPlanoContaEmpresa() {
    const codigoPlanoContaProduto = 3;
    this.planoContaEmpresaService.buscarPorEmpresaECodigo(this.getEmpresa().id, codigoPlanoContaProduto)
      .subscribe({
        next: (data: PlanoContaEmpresa) => {
          this.planoContaEmpresa = data;
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      });
  }


  verificarCodigoExistente(valor: string) {
    if (valor) {
      this.itemProdutoService.codigoExistentePorEmpresa(this.getEmpresa().id, valor).subscribe({
        next: (data: any) => {
          this.codigoExistente = data;
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      });
    } else {
      this.codigoExistente = false;
    }
  }

  abrirDialogValorSugerido() {
    this.exibirDialogValorSugerido = true;
    this.definirValoresPadrao();
    this.obterCustos();
  }


  definirValoresPadrao() {
    this.valorSugerido = 0;
    this.novoValor = 0;
    this.valorLucroObtido = 0;
  }

  obterCustos() {
    this.loadingSpinnerDialog = true;
    this.custoService.obterDadosParaPrecificacao(this.getEmpresa().id).subscribe({
      next: (data: CustoMedio) => {
        this.custoMedio = data;
        this.calcularValorSugerido();
        this.loadingSpinnerDialog = false;
      },
      error: (err: any) => {
        this.loadingSpinnerDialog = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  private calcularValorCompra(): number {
    const valorCompra = this.itemProduto?.valorCompra ?? 0;
    const quantidade = this.itemProduto?.quantidadeUnidadeMedida ?? 1;

    if (quantidade > 1) {
      return valorCompra / quantidade;
    }
    return valorCompra;
  }


  private calcularPercentualCusto(): number {
    const custoFixo = this.custoMedio?.custoFixo ?? 0;
    const comissao = this.itemProduto?.comissaoVenda ?? 0;
    const imposto = this.custoMedio?.imposto ?? 0;
    return custoFixo + comissao + imposto;
  }

  calcularValorSugerido(): void {
    if (!this.itemProduto?.lucro) {
      this.valorSugerido = 0;
      return;
    }

    const valorCompra = this.calcularValorCompra();
    const valorFrete = 0;
    const valorLucroDesejado = valorCompra * (this.itemProduto.lucro / 100);
    const valorComposicao = valorCompra + valorFrete + valorLucroDesejado;

    const percentualCusto = this.calcularPercentualCusto();
    const valorInicial = valorComposicao + (percentualCusto * valorComposicao / 100);
    const diferencaComposicao = (valorInicial - valorComposicao) * (percentualCusto / 100);

    const valorCalculado = valorInicial + diferencaComposicao + (diferencaComposicao * percentualCusto / 100);
    this.valorSugerido = valorCalculado;
  }


  calcularLucroObtido(valor?: number): void {
    this.novoValor = valor ?? 0;

    if (this.novoValor <= 0) {
      this.valorLucroObtido = 0;
      return;
    }

    const valorCompra = this.calcularValorCompra();
    const valorFrete = 0;
    const percentualCusto = this.calcularPercentualCusto();

    const valorCustoReais = this.novoValor * (percentualCusto / 100);
    this.valorLucroObtido = this.novoValor - valorCompra - valorFrete - valorCustoReais;
  }

  confirmarNovoValor() {
    this.itemProduto.valorVenda = this.novoValor;
    this.exibirDialogValorSugerido = false;
  }

}
